/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SpeculatorCheckDto } from '../models/SpeculatorCheckDto';
import type { VitecViewingInfo } from '../models/VitecViewingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormsService {

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsFinalWatch(
        formData?: {
            FirstName?: string;
            LastName?: string;
            Phone?: string;
            EmailAddress?: string;
            EstateId?: string;
            CustomerId?: string;
            GDPR?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/FinalWatch',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsGeneral(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            City?: string;
            ZipCode?: string;
            Comment?: string;
            LeadSourceId?: string;
            ReceiverEmail?: string;
            EmailTitle?: string;
            GDPR?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/General',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsEvaluateResidence(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            OfficeCustomerId?: string;
            ObjectType?: string;
            LeadSourceId?: string;
            LeadMessage?: string;
            GDPR?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/EvaluateResidence',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsValueCheckForm(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            OfficeCustomerId?: string;
            ObjectType?: string;
            LeadSourceId?: string;
            AssignmentSourceId?: string;
            LeadMessage?: string;
            GDPR?: boolean;
            ContactType?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/ValueCheckForm',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsAreaWatch(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            OfficeCustomerId?: string;
            ObjectType?: string;
            LeadSourceId?: string;
            AssignmentSourceId?: string;
            LeadMessage?: string;
            GDPR?: boolean;
            ContactType?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/AreaWatch',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsHeadStart(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            OfficeCustomerId?: string;
            LeadMessage?: string;
            LeadSource?: string;
            GDPR?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/HeadStart',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsGeneralFormVitec(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            OfficeCustomerId?: string;
            ObjectType?: string;
            LeadSourceId?: string;
            AssignmentSourceId?: string;
            LeadMessage?: string;
            GDPR?: boolean;
            ContactType?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/GeneralFormVitec',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsSpeculatorCheckForm(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            Phone?: string;
            EmailAddress?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            OfficeCustomerId?: string;
            ObjectType?: string;
            LeadSourceId?: string;
            LeadMessage?: string;
            GDPR?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/SpeculatorCheckForm',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsApplySpontaneous(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            EmailAddress?: string;
            Phone?: string;
            Attachments?: Array<Blob>;
            LinkedInUrl?: string;
            WorkTitleBroker?: boolean;
            WorkTitleAssistant?: boolean;
            WorkTitleTrainee?: boolean;
            WorkTitleFranchisees?: boolean;
            WorkTitleOther?: boolean;
            WorkTitles?: Array<string>;
            Cities?: Array<string>;
            SelectedCities?: Array<string>;
            CV?: Blob;
            CoverLetter?: Blob;
            Message?: string;
            Gdpr?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/ApplySpontaneous',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsApplyStudent(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            EmailAddress?: string;
            Phone?: string;
            School?: string;
            Grade?: string;
            LinkedInUrl?: string;
            StudingTo?: string;
            StudingToOtherComment?: string;
            InterestedIn?: Array<string>;
            CV?: Blob;
            CoverLetter?: Blob;
            Message?: string;
            Gdpr?: boolean;
            SelectedCities?: Array<string>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/ApplyStudent',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsApplyFranchise(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            EmailAddress?: string;
            Phone?: string;
            Attachments?: Array<Blob>;
            LinkedInUrl?: string;
            WorkTitleBroker?: boolean;
            WorkTitleAssistant?: boolean;
            WorkTitleTrainee?: boolean;
            WorkTitleFranchisees?: boolean;
            WorkTitleOther?: boolean;
            WorkTitles?: Array<string>;
            Cities?: Array<string>;
            SelectedCities?: Array<string>;
            CV?: Blob;
            CoverLetter?: Blob;
            Message?: string;
            Gdpr?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/ApplyFranchise',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsApplyVacantJob(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            EmailAddress?: string;
            Phone?: string;
            IsBroker?: string;
            YearOfExperience?: string;
            OtherCategory?: string;
            LinkedInUrl?: string;
            JobTitle?: string;
            CV?: Blob;
            CoverLetter?: Blob;
            Category?: string;
            ReferrerEmail?: string;
            ReferrerName?: string;
            ReferrerPhone?: string;
            ReferrerImage?: string;
            JobId?: number;
            Message?: string;
            Gdpr?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/ApplyVacantJob',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsSignUpForViewing(
        formData?: {
            FirstName?: string;
            LastName?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            MobilePhone?: string;
            Email?: string;
            ReminderTime?: number;
            GDPR?: boolean;
            TimeSlotId?: string;
            ViewingId?: string;
            CustomerId?: string;
            Viewings?: Array<VitecViewingInfo>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/SignUpForViewing',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param formData
     * @returns any Success
     * @throws ApiError
     */
    public static formsInterest(
        formData?: {
            Firstname?: string;
            Lastname?: string;
            PhoneCell?: string;
            PhoneWork?: string;
            PhoneHome?: string;
            Email?: string;
            Address?: string;
            ZipCode?: string;
            City?: string;
            Message?: string;
            EstateId?: string;
            CustomerId?: string;
            ObjectStreet?: string;
            ObjectCity?: string;
            AgentEmail?: string;
            PUL?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/Interest',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static formsSpeculatorCheck(
        requestBody?: SpeculatorCheckDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Forms/SpeculatorCheck',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param query
     * @returns any Success
     * @throws ApiError
     */
    public static formsGetGepositData(
        query?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Forms/GetGepositData',
            query: {
                'query': query,
            },
        });
    }

    /**
     * @param query
     * @returns any Success
     * @throws ApiError
     */
    public static formsGetGepositDataWithCoords(
        query?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Forms/GetGepositDataWithCoords',
            query: {
                'query': query,
            },
        });
    }

}
